import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { FoundationLayoutComponent } from "./core/components/layout/layout.component";
import { NotFoundComponent } from "./core/components/not-found/not-found.component";

const routes: Routes = [
  {
    path: ":practiceId",
    component: FoundationLayoutComponent,
    children: [
      {
        path: "fee-schedule",
        loadChildren: () =>
          import("src/app/modules/fee-schedule/fee-schedule.module").then(
            (m) => m.FeeScheduleModule
          ),
      },
      {
        path: "practice-fees",
        loadChildren: () =>
          import("./modules/practice-fees/practice-fees.module").then(
            (m) => m.PracticeFeesModule
          ),
      },
      {
        path: "**",
        component: NotFoundComponent,
        data: { title: "Page Not Found" },
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    paramsInheritanceStrategy: "always"
}),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
